import React from "react";
import styles from "./ContactUs.module.scss";
import EmbeddedMap from "../../components/EmbedMaps/EmbeddedMap";
import ContactForm from "../../components/ContactUsForm/ContactUsForm";
const ContactUs = () => {
    return (
        <section className={styles.ContactUs}>

        <div className={styles.ContactUs_Hero}>
            
        {/* <div className={styles.ContactUs_Hero_bg}></div>
        <div className={styles.ContactUs_Hero_text}>
            <h1>
                Contact
            </h1>
        </div> */}
        </div>
        <div className={styles.ContactUs_Form}>

       <ContactForm/>
        <EmbeddedMap/>
        </div>
        </section>
    )
}
export default ContactUs